module.exports = require("@angular/common/http");


//////////////////
// WEBPACK FOOTER
// external "@angular/common/http"
// module id = 11
// module chunks = 0